export default "__VITE_ASSET__JOoBj6OE__"